

export const NuggetsFAQ = () => {
    return (
        <>
            <p><strong>Reguli generale</strong></p>
            <span>Înregistrarea la Ninja Chicken Race este gratuită, însă pentru a participa este necesar un cont activ și validat la Princess Casino.</span>
            <span>Aduni puncte pe baza rulajului realizat. 1 RON pariat = 1 punct. Pariurile trebuie realizate cu bani cash în perioada desfășurării competiției.</span>
            <span>Te rugăm să consulţi Termenii și Condițiile pentru regulile specifice aplicabile.</span>
            <p><strong>Cum câștig</strong></p>
            <span>Câştigătorii Ninja Chicken Race sunt stabiliţi pe baza poziţiei unui jucător în Clasament la finalul fiecărei curse.</span>
            <span>În caz de egalitate, jucătorul cu cel mai mare număr de pariuri plasate va fi clasat pe poziţia mai înaltă.</span>
            <span>Pariul minim pentru Ninja Chicken RACE este de 1 RON.</span>
            <span>Punctajul unui jucător este suma tuturor multiplicatorilor obținuți la jocul eligibil, din pariuri realizate cu bani cash în perioada desfășurării competiției.</span>
            <p><strong>Ce câștig</strong></p>
            <span><strong>Premii în funcție de clasament</strong>: adună cât mai multe puncte și califică-te în topul race-ului pentru un premiu în bani.</span>
            <span><strong>Premii bonus instant</strong>: acordate zilnic aleatoriu jucătorilor care au acumulat minim 100 puncte în ziua respectivă.</span>
            <span><strong>Telefoane iPhone instant:</strong>: se acordă aleatoriu, 2 telefoane în fiecare zi a cursei, la ora 20.00 și la ora 21.00</span>
        </>
    )
}